import firebase from "firebase/app";
import * as z from "zod/mini";

export const ProductSchema = z.object({
  count: z.number(),
  eid: z.optional(z.string()),
  productType: z.string(),
  thumbnail: z.nullable(z.optional(z.string())),
});

export const LineItemSchema = z.object({
  quantity: z.number(),
  thumbnail: z.nullable(z.optional(z.string())),
});

export const SettlementSchema = z.object({
  createdAt: z.nullable(z.instanceof(firebase.firestore.Timestamp)),
  // DocumentReference[]だが、参照先のドキュメント内容のみ必要なため、z.unknown()で許容し使用時に型ガードで検証する
  fulfillmentRefs: z.optional(z.nullable(z.unknown())),
  isCancelled: z.boolean(),
  lineItems: z.optional(z.array(LineItemSchema)),
  orderId: z.nullable(z.number()),
  payType: z.nullable(z.string()),
  products: z.optional(z.array(ProductSchema)),
  status: z.nullable(z.string()),
});
